import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix } from './constants';

// 获取Engagements的图表数据
export const getPublishingTimelineDataInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/accounts/publishing_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// 获取Followers    Growth of Followers   Growth of Engagements的图表数据
export const getFollowersDataInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/accounts/audience_timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// 获取官号表格数据
export const getMetricsTableForDownloadTableList: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/accounts/list`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// byChannel页面的获取头部官号数量
export const getByChannelAccountCount: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/global/get_accounts_by_channels`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

// byAccount页面的获取TOP N的内容
export const getByAccountTopN: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/accounts/account_top`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getPostUserInfo: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/global/get_anchors_detail`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
